<template>
  <div class="modal-backdrop" v-if="this.$store.state.modal.createCategory">
    <div class="modal-mask" tabindex="-1">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Создание категории</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" @click="close"></button>
          </div>
          <div class="modal-body">
            <div class="form-group mb-1">
              <label class="col-form-label">Название</label>
              <input type="text" class="form-control" v-model="category.name" placeholder="Название категории">
            </div>
            <div class="form-group mb-1">
              <label class="col-form-label">URL</label>
              <input type="text" class="form-control" v-model="category.url" placeholder="URL">
              <div class="form-text">Пример: meat</div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="close">Закрыть</button>
            <button type="button" class="btn btn-primary" @click="createCategory">Создать категорию</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'create-category',
  data: function(){
    return{
      category: {
        name: '',
        url: '',
      }
    }
  },
  methods: {
    createCategory: function(){
      this.$store.dispatch('createCategory', this.category);
    },
    close: function() {
      this.$store.state.modal.createCategory = false;
    },
  },
};
</script>
